import React from 'react';
import './styles.scss';
import {cn} from "../../../utils/utils";
import {useSelector} from "react-redux";
import users from "../../users";

type OptionButtonViewProps = {
    onClick: (e: React.MouseEvent) => void;
    text: React.ReactNode;
    children?: React.ReactNode;
    title?: string;
    icon: React.ReactNode;
    hidden?: boolean;
    disabled?: boolean;
    style?: React.CSSProperties;
    className?: string;
    active?: boolean;
}

const OptionButtonView = ({
                              onClick,
                              text,
                              title,
                              icon,
                              hidden,
                              disabled,
                              style,
                              className,
                              children,
                              active
                          }: OptionButtonViewProps) => {

    const darkMode = useSelector(users.selectors.isDarkMode)

    if (hidden) {
        return null;
    }

    return (
        <div title={title}
             style={style}
             className={cn("option-button", {"option-button-dark": darkMode}, {"option-button__disabled": disabled}, {"option-button__active": active}, className)}
             onClick={(e) => {
                 if (!disabled) {
                     onClick(e);
                 }
             }}>
            {icon && <div className="option-button__icon">
                {icon}
            </div>}
            <span>
                {text || children}
            </span>
        </div>
    );
}

export default OptionButtonView;
